import { googleLogout } from '@react-oauth/google';

type UseGoogleLogout = {
  logoutFromGoogle: () => void;
};

const useGoogleLogout = (): UseGoogleLogout => ({
  logoutFromGoogle: googleLogout,
});

export default useGoogleLogout;
